import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { UserContext } from "../context/UserContext"; // ✅ 1. Import Context
import BottomNavigation from "../components/BottomNavigation";

function More() {
    const navigate = useNavigate();
    // const [showLogoutModal, setShowLogoutModal] = useState(false);

    // ✅ 2. Get User Data from Context (No API Call Here)
    const { user, loading } = useContext(UserContext);

    const menuGroups = [
        {
            title: "Gaming Zone",
            items: [
                { label: "How to Play", icon: "controller", path: "/how-to-play", color: "primary" },
                { label: "Fantasy Point System", icon: "bar-chart-fill", path: "/point-system", color: "info" },
                { label: "Refer & Earn", icon: "gift-fill", path: "/refer-earn", color: "warning" },
            ]
        },
        {
            title: "App & Support",
            items: [
                { label: "Help & Support", icon: "headset", path: "/help-support", color: "success" },
                { label: "Settings", icon: "gear-fill", path: "/settings", color: "secondary" },
            ]
        }
    ];

    // ✅ 4. SHIMMER LOADER (UI MAROON THEME)
    if (loading) return (
        <>
            <Navbar />
            <div style={{ minHeight: "100vh", background: "#f4f6f9" }}>
                {/* Shimmer Header in Maroon (Updated for new banner layout) */}
                <div className="pb-5 pt-5 px-3 position-relative placeholder-glow text-center"
                    style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", borderBottomLeftRadius: "30px", borderBottomRightRadius: "30px", marginBottom: "-20px", height: "220px", boxShadow: "0 10px 20px rgba(128,0,0,0.15)" }}>
                    <div className="placeholder rounded-circle bg-light opacity-50 mb-3 mx-auto" style={{ width: "60px", height: "60px", display: "block" }}></div>
                    <span className="placeholder col-6 bg-light opacity-50 rounded mb-2 mx-auto d-block" style={{ height: "25px" }}></span>
                    <span className="placeholder col-4 bg-light opacity-50 rounded mx-auto d-block" style={{ height: "15px" }}></span>
                </div>
                {/* Shimmer List */}
                <div className="container-fluid px-3 px-md-4 placeholder-glow" style={{ marginTop: "50px" }}>
                    {[1, 2].map((i) => (
                        <div key={i} className="mb-4">
                            <span className="placeholder col-4 bg-secondary opacity-25 mb-2 rounded"></span>
                            <div className="card border-0 shadow-sm" style={{ borderRadius: '20px', height: '150px' }}></div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );

    // Agar user nahi hai (Safety Check)
    if (!user) {
        navigate('/auth');
        return null;
    }

    return (
        <>
            <Navbar />
            <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "100px" }} className="mt-5 pt-3">

                {/* === BRANDED EXPLORE HEADER IN MAROON === */}
                <div
                    className="pb-5 pt-5 px-3 text-center position-relative overflow-hidden"
                    style={{
                        background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)", // 🔥 Maroon Theme
                        borderBottomLeftRadius: "30px",
                        borderBottomRightRadius: "30px",
                        marginBottom: "-20px",
                        boxShadow: "0 10px 20px rgba(128,0,0,0.15)"
                    }}
                >
                    {/* Background faint icon for premium look */}
                    <i className="bi bi-grid-3x3-gap-fill position-absolute text-white" style={{ fontSize: "10rem", opacity: "0.05", right: "-20px", top: "-20px", transform: "rotate(15deg)" }}></i>

                    <div className="text-white position-relative z-1">
                        <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 shadow-sm" style={{ width: "65px", height: "65px", backgroundColor: "rgba(255, 255, 255, 0.15)", border: "2px solid rgba(255, 255, 255, 0.2)" }}>
                            <i className="bi bi-grid-fill" style={{ fontSize: "2rem", color: "#ffcccc" }}></i>
                        </div>
                        <h2 className="fw-bolder mb-1" style={{ letterSpacing: "0.5px" }}>Explore Win11</h2>
                        <p className="text-white opacity-75 small mb-0 px-4">Discover features, gaming rules, and account settings</p>
                    </div>
                </div>

                <div className="container-fluid px-3 pt-5 mt-2 px-md-4">

                    {/* === MENU GROUPS === */}
                    {menuGroups.map((group, idx) => (
                        <div key={idx} className="mb-4">
                            <h6 className="fw-bold text-muted ps-2 mb-2 text-uppercase small ls-1">{group.title}</h6>
                            <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: "20px" }}>
                                <div className="list-group list-group-flush">
                                    {group.items.map((item, i) => (
                                        <button
                                            key={i}
                                            className="list-group-item list-group-item-action p-3 border-0 border-bottom d-flex align-items-center gap-3 bg-white"
                                            onClick={() => navigate(item.path)}
                                            style={{ transition: "0.2s" }}
                                        >
                                            <div className={`rounded-circle bg-${item.color}-subtle text-${item.color} d-flex align-items-center justify-content-center flex-shrink-0`}
                                                style={{ width: "45px", height: "45px" }}>
                                                <i className={`bi bi-${item.icon} fs-5`}></i>
                                            </div>

                                            <div className="flex-grow-1 text-start">
                                                <span className="fw-bold text-dark">{item.label}</span>
                                            </div>

                                            <i className="bi bi-chevron-right text-muted small"></i>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* === FOOTER === */}
                    <div className="text-center pb-3">
                        <small className="text-muted fw-bold">Win11 v1.0.0</small>
                        <p className="text-muted small opacity-50 mb-0">Made with ❤️ for Cricket Fans</p>
                    </div>

                </div>

                <style>{`.ls-1 { letter-spacing: 1px; }`}</style>
            </div>
            <BottomNavigation />
        </>
    );
}

export default More;